import * as React from "react";
import type { SVGProps } from "react";
const SvgExtendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="extend_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M256 85.333A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333H256zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zM512 298.667a42.667 42.667 0 0 1 42.667 42.666v128h128a42.667 42.667 0 1 1 0 85.334h-128v128a42.667 42.667 0 1 1-85.334 0v-128h-128a42.667 42.667 0 1 1 0-85.334h128v-128A42.667 42.667 0 0 1 512 298.667z"
    />
  </svg>
);
export default SvgExtendIcon;
